<template>
  <block component-name="block-grid-mirage-experience">
    <template v-slot:default="blockData">
      <grid-stores
        class="w-full"
        :use-minimal-cards="false"
        :loading="blockData?.loading"
        :items="$attrs.data.body.items"
      />
    </template>
  </block>
</template>
